const $ = require('jQuery');

const WebinarsSearch = function (el) {
  this.$el = $(el);
  this.$featuresHeroContent = this.$el.find('.js-webinar-archive-feature-title');
  this.$searchTermWrap = this.$el.find('.js-webinar-archive-search-title-wrap');
  this.$searchTerm = this.$el.find('.js-webinar-archive-search-title');
  this.$searchbox = this.$el.find('.js-webinar-archive-searchbox');
  this.$searchboxContainer = this.$el.find('.js-webinar-archive-searchbox-container');

  this.$resultsUpcomingWrap = this.$el.find('.js-webinar-archive-upcoming');
  this.$resultsAllWrap = this.$el.find('.js-webinar-archive-all');

  this.$noResultsUpcoming = this.$el.find('.js-webinar-archive-upcoming-no-results');
  this.$noResultsAll = this.$el.find('.js-webinar-archive-all-no-results');
  
  this.$searchbox.on('keyup', this.onSearchboxChange.bind(this));
}

WebinarsSearch.prototype.scrollToTopOfPage = function () {
  const $body = $("html, body");
  $body.stop().animate({scrollTop:0}, 500, 'swing', () => {});
}

WebinarsSearch.prototype.showSearchResults = function () {
  this.$searchTermWrap.removeClass('hide');
}

WebinarsSearch.prototype.getValueFromQueryString = function (key) {
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;
  const value = searchParams.get(key);
  return value;
}

WebinarsSearch.prototype.getSearchQueryString = function () {
  return this.getValueFromQueryString('search');
}

WebinarsSearch.prototype.prefillSearchField = function (value) {
  this.$searchbox.val(value);
}

WebinarsSearch.prototype.filterResources = function (keyword, resources) {
  const keywordRegex = new RegExp(keyword, 'i');

  const filtered = resources.filter(post => {
    const title = post.post_title;
    const excerpt = post.post_excerpt;

    return keywordRegex.test(title) || keywordRegex.test(excerpt);
  });

  return filtered;
}

WebinarsSearch.prototype.showSearchResultsByPostId = function (postIds) {
  $('.js-search-result').addClass('hide');

  postIds.forEach(postId => {
    const idSelector = '#webinar-' + postId;
    const $result = $(idSelector);
    $result.removeClass('hide');
  });
}

WebinarsSearch.prototype.updateSearchHeaderTerm = function (keyword) {
  const searchTerm = keyword
    ? ('"' + keyword + '"')
    : '...';

  this.$searchTerm.text(searchTerm);
}

WebinarsSearch.prototype.setSearchQueryString = function (keyword) {
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;

  if (keyword === '') {
    searchParams.delete('search');
  } else {
    searchParams.set('search', keyword);
  }

  const state = url.pathname + url.search + url.hash;

  window.history.replaceState(null, window.document.title, state);
}

WebinarsSearch.prototype.clearSearchbox = function () {
  this.$searchbox.val('');
  this.$searchTermWrap.addClass('hide');
}

WebinarsSearch.prototype.closeSearchPage = function () {
  this.showFeatures();
  this.clearSearchbox();
}

WebinarsSearch.prototype.showFeatures = function () {
  this.$featuresHeroContent.removeClass('hide');
}

WebinarsSearch.prototype.hideFeaturesTitle = function () {
  this.$featuresHeroContent.addClass('hide');
}

WebinarsSearch.prototype.onSearchboxChange = function (e) {
  const keyword = e.target.value;
  const resources = window.resources;

  const filteredPosts = this.filterResources(keyword, resources);
  const resultCount = filteredPosts.length;
  const filteredPostIds = filteredPosts.map(post => post.ID);

  this.showSearchResultsByPostId(filteredPostIds);

  if (keyword === '') {
    this.closeSearchPage();
  } else {
    this.hideFeaturesTitle();
    this.showSearchResults();
  }

  this.updateSearchHeaderTerm(keyword);

  this.setSearchQueryString(keyword);

  if(!this.$resultsUpcomingWrap.height()) {
    this.$noResultsUpcoming.removeClass('hide');
  } else {
    this.$noResultsUpcoming.addClass('hide');
  }

  if(!this.$resultsAllWrap.height()) {
    this.$noResultsAll.removeClass('hide');
  } else {
    this.$noResultsAll.addClass('hide');
  }
}

$(document).ready(function () {
  $('.js-webinar-archive-page').each(function () {
    new WebinarsSearch(this);
  });
});
